export default {
  editPermissions: 'Berechtigungen setzen',
  safePassword: {
    summary: 'Initiales Passwort kopieren',
    details: 'Das folgende initiale Passwort wird nur einmal angezeigt. Bitte notieren Sie es sorgfältig und übermitteln Sie es dem neuen Benutzer. Beim ersten Login wird der Benutzer aufgefordert, ein dauerhaftes Passwort festzulegen.',
  },
  title: 'Neuen Benutzer anlegen',
};
